import * as Yup from "yup";

// ----------------------------------------------------------------------

export const AdminSchema = Yup.object().shape({});
